import { Type } from '@angular/core';

export class DevFuncConfirmItem {
  constructor(public component: Type<any>, public name: string, public data?: any) {}
}
